import logic from "src/utils/genLogic";
import actions, { ActionTypes } from "./actions";
import { push } from "connected-react-router";
import { Trans } from "@lingui/react";
const apiNamespace = "StarterKits";

const getStarterKitLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_STARTER_KIT,
});

const getAllStarterKitsLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_ALL_STARTER_KITS,
});

const createStarterKitLogic = logic(apiNamespace, {
  actionName: ActionTypes.CREATE_STARTER_KIT,
  successCb: (dispatch) => {
    dispatch(push("/starterKits/list"));
  },
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_added_successfully" />,
});
const editStarterKitLogic = logic(apiNamespace, {
  actionName: ActionTypes.EDIT_STARTER_KIT,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_edited_successfully" />,
});
const deleteStarterKitLogic = logic(apiNamespace, {
  actionName: ActionTypes.DELETE_STARTER_KIT,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_deleted_successfully" />,
});

export default [
  getStarterKitLogic,
  getAllStarterKitsLogic,
  createStarterKitLogic,
  editStarterKitLogic,
  deleteStarterKitLogic,
];
